import { common } from "../../constants/apiUrl";
import { IApiResponse } from "../../models/IAPIResponse";
import APIService from "../../helper/api-service";
import { urlBinder } from "../../helper/url-binder";

export default new (class FreshmanAdminApproval {
    public getProcessApproval = async (token: string): Promise<IApiResponse<boolean>> => {
        try {
            let endPoint = urlBinder(common.GET_ADMIN_APPROVAL, [`${token}`]);
            const response = await APIService.get(endPoint);
            return response.data as IApiResponse<boolean>;
        } catch (error: any) {
            if (error.response) {
                return error.response as IApiResponse<boolean>;
            } else {
                throw error;
            }
        }
    };
})();